/**
 * @generated SignedSource<<86263862ad5df21f5a1716b84bf4ad11>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProjectParticipantsPage_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"AlertVoxpopmeVideoAnalysis_user" | "ParticipantsTable_user">;
  readonly " $fragmentType": "ProjectParticipantsPage_user";
};
export type ProjectParticipantsPage_user$key = {
  readonly " $data"?: ProjectParticipantsPage_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectParticipantsPage_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectParticipantsPage_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AlertVoxpopmeVideoAnalysis_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ParticipantsTable_user"
    }
  ],
  "type": "UserNode",
  "abstractKey": null
};

(node as any).hash = "d07485928a6897ed3774894c51955d99";

export default node;
